import * as React from 'react';
import {EditorPlane} from "../features/react-editor/wired/EditorPlane";

type Props = {

};
export const App = (props: Props) => {
    return (
        <EditorPlane />
    );
};
